import { isObject } from "../utils.js";
function valueIn(givenValue, expectedValue) {
  if (isObject(expectedValue)) {
    return Object.values(expectedValue).includes(givenValue);
  }
  if (Array.isArray(expectedValue) || typeof expectedValue === "string") {
    return expectedValue.indexOf(givenValue) > -1;
  }
  throw new Error(
    `In operator: Unsupported values to compare ${JSON.stringify(
      givenValue
    )}, ${JSON.stringify(expectedValue)}`
  );
}
export {
  valueIn
};
//# sourceMappingURL=in.js.map
